export default __webpack_public_path__ + "fonts/FuturaPassata.eot";